export enum TripReportType {
    TIME_DURATION_IN_CHECKPOINT = 'TIME_DURATION_IN_CHECKPOINT',
    DEVIATION_REPORT = 'DEVIATION_REPORT',
    ORDERS_STATUS = 'ORDERS_STATUS',
    CYCLE_TIME_REPORT = 'CYCLE_TIME_REPORT',
    DISTANCE_BETWEEN_CHECKPOINTS = 'DISTANCE_BETWEEN_CHECKPOINTS',
    ADMIN_REPORT = 'ADMIN_REPORT',
    POI_DETAIL = 'POI_DETAIL',
    TABLE_VIEW = 'TABLE_VIEW',
}
